import React from "react";
import { Modal, Button } from "react-bootstrap";

export default function QuickThanksModal({ show, onClose }) {
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Response Sent</Modal.Title>
      </Modal.Header>
      <Modal.Body>✅ A quick “Thanks!” has been successfully sent!</Modal.Body>
      <Modal.Footer>
        <Button variant="success" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
